<template>
  <b-modal size="md" button-size="sm" hide-footer v-model="showModal" @hidden="cancelar" :title="prefix + title">
    <div>
      <b-row>
        <b-col>
          <b-form @submit.prevent="save">
            <b-card>
              <b-form-row>
                <lg-form-input
                  invalidFeedback="Informe uma descrição válida!"
                  :error="$v.form.descMotivoAgregacao"
                  v-model="form.descMotivoAgregacao"
                  label="Descrição: *"
                  cols="12"
                />
              </b-form-row>
              <b-form-row>
                <b-form-radio-group
                  size="sm"
                  v-model="form.situacaoMotivoAgregacao"
                  :options="options"
                  name="situacao-options"
                  class="d-flex col-12"
                />
              </b-form-row>

              <div class="d-flex justify-content-center mt-3">
                <b-button id="salvarMotivoAgregacao" type="submit" variant="success" style="height: 30px" pill size="sm">
                  <div class="btn-size-alinhamento">
                    <b-icon icon="check-circle" />
                  </div>
                  <b-tooltip target="salvarMotivoAgregacao" title="Salvar" triggers="hover"></b-tooltip>
                </b-button>
                <b-button id="cancelarMotivoAgregacao" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm" variant="danger">
                  <div class="btn-size-alinhamento">
                    <b-icon icon="x-circle" />
                  </div>
                  <b-tooltip target="cancelarMotivoAgregacao" title="Cancelar" triggers="hover"></b-tooltip>
                </b-button>
              </div>
            </b-card>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import { FormResourceMixin } from "@/core/mixins/resource"
import { required } from "vuelidate/lib/validators"

export default {
  components: {
    LgFormInput,
  },
  props: {
    isModal: Boolean,
    id: Number,
    prefix:{
      type:String,
      default: ""
    },
    title:{
      type:String,
      default: "Cadastro"
    }
  },
  computed: {
    
  },
  mixins: [FormResourceMixin],
  validations: {
    form: {
      descMotivoAgregacao: { required },
      situacaoMotivoAgregacao: { required },
    },
  },
  data() {
    return {
      showModal: true,
      options: [
        { text: "Ativo", value: "1" },
        { text: "Inativo", value: "0" },
      ],
      form: {
        descMotivoAgregacao: "",
        situacaoMotivoAgregacao: 1,
      },
    }
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/motivoagregacao`)
  },
  async mounted() {
    if (this.id) {
      const { data } = await this.$service.findById(this.id)
      this.form = data
    } else {
      this.form.situacao = 1
    }
  },
  methods: {
    async save() {
      if (!this.formIsValid) {
        this.$v.$touch()
        this.$notify({
          type: "danger",
          message: "Verifique os campos do cadastro.",
        })
        return
      }
      try {
        await this.$saveResource(
          this.form,
          "",
          true,
          {},
          this.isModal
        )
        this.cancelar();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Erro ao salvar`,
        })
        console.error(error)
      }
    },
    cancelar() {
      this.$emit("close")
    },
  },
}
</script>
